import { AdView } from '../ad-view'
import { BaseComponent, BaseFullscreenToggle, BaseSpacer } from '../base'
import { CloseButton } from '../close-button'
import { ClosedCaptionsButton } from '../closed-captions-button'
import { ControlBar } from '../control-bar'
import { InfoButton } from '../info-button'
import { PlayButton } from '../play-button'
import { PlayNext } from '../play-next'
import { PlayNextEpisode } from '../play-next-episode'
import { PlayPauseAnimation } from '../play-pause-animation'
import { PlayPrevious } from '../play-previous'
import { PlaylistButton } from '../playlist-button'
import { ArrowSeekHandlers, ProgressControl } from '../progress-control'
import { RewindButton } from '../rewind-button'
import { SeekToLive } from '../seek-to-live'
import { Settings } from '../settings'
import { SkipSegmentButton } from '../skip-segment'
import { TapToUnmute } from '../tap-to-unmute'
import { Title } from '../title'
import { VolumePanel } from '../volume-panel'
import { Player } from './player'

import './default-player-controls-behaviour.css'
import './default-player.css'
import './disable-player-mode.css'

/**
 * Default player configuration, used by Pureya
 */
export const defaultPlayer = Player.as('.vjs-x-player', [
  // Top bunk
  BaseComponent.as('.vjs-x-top-bunk', [
    // currently playing video title
    Title,

    // space between title and close button
    BaseSpacer,

    // chromecast button
    // https://github.com/silvermine/videojs-chromecast/blob/ee87f9bcad423b48560cbb5340b5b577d61af853/src/js/components/ChromecastButton.js
    'chromecastButton',

    // close button
    CloseButton,
  ]),

  // Middle bunk
  BaseComponent.as('.vjs-x-middle-bunk', [
    // for "touch" devices only
    RewindButton.as('.vjs-x-rewind-button.vjs-x-rewind-left-button'),
    PlayPrevious,
    PlayButton,
    PlayNext,
    RewindButton.as('.vjs-x-rewind-button.vjs-x-rewind-right-button'),

    // Animation of play / pause on L / XL screens
    PlayPauseAnimation,

    // "Tap to unmute button" for touch devices combined
    TapToUnmute,

    // ad view with counter and skip button
    AdView,
  ]),

  // Bottom bunk
  BaseComponent.as('.vjs-x-bottom-bunk', [
    // progress control
    ProgressControl,

    // Keyboard seek handlers
    ArrowSeekHandlers,

    // control bar with play/pause, volume, live indicator(button) and so on controls
    ControlBar.as('.vjs-x-control-bar', [
      // displays the current time
      // BaseCurrentTimeDisplay.as(),

      // separator between the current time and duration
      // BaseTimeDivider.as(),

      // displays the duration
      // BaseDurationDisplay.as(),

      // central play toggle button
      PlayButton,

      // rewind left button
      RewindButton.as('.vjs-x-rewind-button.vjs-x-rewind-left-button'),

      // rewind right button
      RewindButton.as('.vjs-x-rewind-button.vjs-x-rewind-right-button'),

      // MuteToggle and VolumeControl combined
      VolumePanel,

      // status of live edge and button to seek to live edge
      SeekToLive,

      // space to move latter controls to the right side
      BaseSpacer,

      // Play next content button
      PlayPrevious,

      // Play previous content button
      PlayNext,

      // Play next episode button
      PlayNextEpisode,

      // Playlist button
      PlaylistButton,

      // Button to toggle info view showing
      InfoButton,

      // Closed Captions button
      ClosedCaptionsButton,

      // Settings control, with button and menu
      Settings,

      // toggle Picture-in-Picture mode
      // BasePictureInPictureToggle.as(),

      // toggle fullscreen video
      BaseFullscreenToggle.as(),
    ]),
  ]),

  // skip intro / skip credits — root level to stay visible in hidden mode
  SkipSegmentButton,
])
